import api from '../api';

const SESSIONS = 'uploads/sessions';

const dataOf = ({ data }) => data;

export const open = (payload) => api.post({ type: 'user', service: SESSIONS, data: payload }).then(dataOf);

export const partUrls = (sessionId, partNumbers, failure = null) =>
    api.post({ type: 'user', service: `${SESSIONS}/${sessionId}/part-urls`, data: { partNumbers, failure } }).then(dataOf);

export const parts = (sessionId) => api.get({ type: 'user', service: `${SESSIONS}/${sessionId}/parts` }).then(dataOf);

export const complete = (sessionId, metrics) =>
    api.post({ type: 'user', service: `${SESSIONS}/${sessionId}/complete`, data: { metrics } }).then(dataOf);

export const abort = (sessionId) => api.post({ type: 'user', service: `${SESSIONS}/${sessionId}/abort`, data: {} }).then(dataOf);

export const listOpen = () => api.get({ type: 'user', service: SESSIONS }).then(dataOf);
